import { z } from "zod";
import { DomainModelSchema } from "../util/index.ts";
import { ResourcesSchema } from "../util/resources.ts";

export const AssetType = {
  FACILITY: "facility",
  EQUIPMENT: "equipment",
  DEVICE: "device",
  FLOW: "flow",
  ASSET_GROUP: "asset_group",
} as const;
export type AssetTypeType = (typeof AssetType)[keyof typeof AssetType];

export const AssetTypeSchema = ResourcesSchema.extract([
  "facility",
  "equipment",
  "device",
  "flow",
  "asset_group",
]);

export const AssetStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  DEPRECATED: "deprecated",
} as const;
export type AssetStatusType = (typeof AssetStatus)[keyof typeof AssetStatus];

export const AssetSchema = z
  .object({
    name: z.string(),
    asset_type: AssetTypeSchema,
  })
  .merge(DomainModelSchema)
  .describe("Schema for an asset in the Node API");

export type AssetSchemaType = z.infer<typeof AssetSchema>;
